import React from "react";
import { getIconPaths, parseIconPaths } from "./IconLibrary";
import { IconLibrary } from "@/interfaces/IconLibrary";


interface IconProps {
  iconName: IconLibrary;
  className?: string;
  color?: string;
  sizeInPx?: string;
  keepMarkUp?: boolean
}



const Icon = ({ iconName, className = "", color = "black", sizeInPx = "24"}: IconProps) => {
  //certain icons contain a number of paths.
  //each path will require styling applied to it
  const paths = getIconPaths(iconName);
  const pathElements = parseIconPaths((paths as any)?.paths || paths);

  return (
    <div data-testid="thrive-icon" className={`thrive-icon ${className}`} >
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80 80" width={`${sizeInPx}px`} height={`${sizeInPx}px`} aria-hidden>
        {pathElements.map((pathElement, index) => (
          <path key={index} d={pathElement[0]} fill={color} fillRule={pathElement[1] as CanvasFillRule} clipRule={pathElement[2] as CanvasFillRule}/>
        ))}
      </svg>
    </div>
  );
};

export default Icon;